module.exports = __webpack_public_path__ + "img/Truppführer_LogV.74f0bb20.svg";